import styled from 'styled-components';

import Picture from 'components/picture';
import { default as DefaultRadioButton } from 'components/radio-button';

export const Container = styled.div`
  display: flex;
  width: 15rem;
  height: 14rem;
  background-color: ${Styles.color.white};
  color: ${Styles.color.black};
  flex-direction: column;
  border-radius: 1rem;
  cursor: pointer;
`;

export const ImageContainer = styled(Picture)`
  flex: 1 0;
  border-radius: 1rem 1rem 0 0;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  padding: 0.6rem 0.75rem;
  width: 100%;
  position: relative;
`;

export const TitleText = styled.h2`
  font-size: 1.3rem;
  font-weight: ${Styles.fontWeight.heavy};
  color: ${Styles.color.black};
  margin: 0;
  line-height: 1.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  text-align: left;
`;

export const RadioButton = styled(DefaultRadioButton)`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
`;
